
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import VFormBuilder from '../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import StackedForm from '../../mixins/StackedForm';
import CustomerGroup from '@/mixins/CustomerGroup';
import { HealthCheck as HealthCheckModel } from '@/interfaces/models/HealthCheck';
import { Venue } from '@/interfaces/models/Venue';
import { venueFilter } from '@/util/helper';

@Component({
  components: { VFormBuilder },
})
export default class HealthCheckForm extends mixins(StackedForm, CustomerGroup) {
  @Prop({ type: Boolean, default: false }) public editing!: boolean;
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  public selectedCustomerGroup: string = '';
  public selectedVenues: string[] = [];

  get items() {
    return [
      {
        name: 'customerGroup',
        type: InputType.Autocomplete,
        label: 'healthCheck.form.customerGroup',
        items: this.scopedCustomerGroups,
        multiple: false,
        rules: !this.selectedVenues.length ? 'required' : '',
        change: this.onCustomerGroupSelect,
      },
      {
        name: 'venues',
        type: InputType.Autocomplete,
        label: 'healthCheck.form.venues',
        multiple: true,
        itemValue: '_id',
        itemText: 'name',
        items: this.venues,
        filter: venueFilter,
        rules: !this.selectedCustomerGroup ? 'required' : '',
        change: this.onVenuesSelect,
      },
    ];
  }

  public mounted() {
    if (!this.editing) {
      return;
    }

    const initVals = this.initialValues as HealthCheckModel;

    if (initVals?.customerGroup) {
      this.selectedCustomerGroup = initVals.customerGroup;
    }

    if (initVals?.venues?.length) {
      this.selectedVenues = initVals.venues;
    }
  }

  public onCustomerGroupSelect() {
    const selectedCustomerGroup = this.$refs.form.getData()?.customerGroup;

    if (selectedCustomerGroup) {
      this.selectedCustomerGroup = selectedCustomerGroup;
      this.$refs.form.setValue('venues', []);
      this.selectedVenues = [];
    }
  }

  public onVenuesSelect() {
    const selectedVenues = this.$refs.form.getData()?.venues;

    if (selectedVenues?.length) {
      this.selectedVenues = selectedVenues;
      this.$refs.form.setValue('customerGroup', '');
      this.selectedCustomerGroup = '';
    }
  }

  public getData() {
    const data = {
      ...this.$refs.form.getData(),
    };

    if (!data.customerGroup && data.venues?.length) {
      delete data.customerGroup;
    }

    if (!data.venues?.length && data.customerGroup) {
      delete data.venues;
    }

    return data;
  }
}
